import { render } from "./gameRulesView.vue?vue&type=template&id=73204167"
const script = {}

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__